<template>
  <div class="teamWarp" v-if="isMobile != 0">
    <div class="pc" v-if="isMobile == 1">
      <header-view ref="headers"></header-view>
      <div class="page page-5" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
        <div class="page5Warp">
          <div class="title fAb flexSw">
            <div>Viewpoint</div>
            <PcBak :home-index="5"></PcBak>
          </div>
          <div class="newsWarp">
            <div class="newRight">
              <div class="homeAtrList">
                <div class="homeAtrItem" @click="goViewPointDetail(v)" v-for="(v,i) in newsList.list">
                  <div class="atrTitle fOH">{{ v.title }}</div>
                  <div class="atrDesc fOH">{{ v.time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile pw100" v-else>
      <newsMobileView @goDetail="goViewPointDetail"></newsMobileView>
    </div>
  </div>
</template>
<script>

import headerView from "@/components/Common/Header.vue";
import newsMobileView from "@/components/Mobile/viewPoint.vue"
import PcBak from "@/components/Common/pcBak.vue";

export default {
  components: {PcBak, headerView, newsMobileView},
  data() {
    return {
      headerHeight: 104,
      footerHeight: 20,
      tList: [],
      page:1,
      limit:100,
    }
  },
  created() {
    this.$store.dispatch('setPageCurrentIndex', 5)
    this.getList()
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    newsList(){
      return this.$store.getters.viewPointList
    }
  },
  methods: {
    async getList(){
      let {data} = await this.$api.getData('view-point/list',{page:this.page,limit:this.limit})
      this.$store.dispatch('setStoreByKeyData',{key:'setViewPointList',data:data})
    },
    async goViewPointDetail(v){
      if(v.id){
        await this.$store.dispatch('setStoreByKeyData', {key: 'setViewPointInfo', data: v})
        this.$router.push({name:"ViewpointDetail",query:{id:v.id}})
      }
    }
  }
}
</script>

<style scoped lang="scss">

.page-5 {
  background-image: url("../../assets/image/page7_bg.png");
  height: 100vh;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .page5Warp {
    height: 100%;
    width: 70%;
    box-sizing: border-box;
    padding: 1rem 0 1rem;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow: hidden;

    .newsWarp {
      width: 100%;
      display: flex;
      flex: 1;
      align-items: stretch;
      overflow: auto;
      -ms-overflow-style: auto; /* IE 和 Edge */
      scrollbar-width: auto; /* Firefox */
      .newRight {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        .newsMoreBtn {
          display: flex;
          justify-content: flex-end;

          .newsMoreBtnItem {
            display: inline-block;
            padding: .8rem 3rem;
            color: #fff;
            border: .12rem solid #fff;
            font-size: .9rem;
            cursor: pointer;
            margin-top: 2rem;
          }
        }

        .homeAtrList {
          .homeAtrItem:first-child {
            padding-top: 0 !important;
          }

          .homeAtrItem {
            cursor: pointer;
            border-bottom: .05rem solid rgba(255,255,255,.6);
            padding: 1.5rem 0;

            .atrTitle {
              font-size: 1rem;
              line-height: 1.6rem;
              color: #fff;
            }

            .atrDesc {
              font-size: .75rem;
              margin-top: .5rem;
              color: #8FCADD;
            }

          }
        }
      }
    }

    .title {
      text-align: left;
      padding-bottom: 2rem;
      color: #fff;
      font-size: 2.2rem;
      width: 100%;
    }
  }
}
</style>
